<div class="incoming-call-container">
  <div class="call-icon">
    <span nz-icon nzType="phone" nzTheme="outline"></span>
  </div>

  <div class="call-details">
    <div class="call-detail-row">
      <span class="label">Caller</span>
      <span class="value">{{ nzModalData.call.name }}</span>
    </div>
    <div class="call-detail-row">
      <span class="label">Phone</span>
      <span class="value">{{ nzModalData.call.phoneNumber }}</span>
    </div>
    <div class="call-detail-row">
      <span class="label">Last Salesman</span>
      <span class="value">{{ nzModalData.call.lastUser || 'N/A' }}</span>
    </div>
    <div class="call-detail-row">
      <span class="label">Last Call</span>
      <span class="value">{{ nzModalData.call.lastCall || 'N/A' }}</span>
    </div>
  </div>

  <div class="call-actions">
    <button nz-button nzType="primary" nzSize="large" (click)="openCustomer()" *ngIf="nzModalData.call.isLinked">
      <span nz-icon nzType="user" nzTheme="outline"></span>
      View Customer
    </button>
    <button nz-button nzType="primary" nzSize="large" (click)="handleCall()" *ngIf="!nzModalData.call.isLinked">
      <span nz-icon nzType="phone" nzTheme="outline"></span>
      Handle Call
    </button>
    <button nz-button nzType="default" nzSize="large" (click)="dismiss()">
      Dismiss
    </button>
  </div>
</div>
